export { default } from './AutomaticSetup';
